module.exports = __webpack_public_path__ + "data/data.3556d2cc13265c0d01d9ea41daa56f48.csv";